import debounce from 'lodash/debounce';
import { Tag } from '@zendeskgarden/react-tags';
import React from 'react';
import { Dropdown, Hint, Menu, Item, Multiselect, Field, Label } from "@zendeskgarden/react-dropdowns";


function CountriesDropdown({ options = [], selectedItems = [], setSelectedItems = () => {} }) {
  const [inputValue, setInputValue] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [matchingOptions, setMatchingOptions] = React.useState(options);

  /**
   * Debounce filtering
   */
  const filterMatchingOptionsRef = React.useRef(
    debounce(value => {
      const matchingOptions = options.filter(option => {
        return (
          option
            .trim()
            .toLowerCase()
            .indexOf(value.trim().toLowerCase()) !== -1
        );
      });

      setMatchingOptions(matchingOptions);
      setIsLoading(false);
    }, 300)
  );

  React.useEffect(() => {
    setIsLoading(true);
    filterMatchingOptionsRef.current(inputValue);
  }, [inputValue]);

  const renderOptions = () => {
    if (isLoading) {
      return <Item disabled>Loading items...</Item>;
    }

    if (matchingOptions.length === 0) {
      return <Item disabled>No matches found</Item>;
    }

    return matchingOptions.map(option => (
      <Item key={option} value={option}>
        <span>{option}</span>
      </Item>
    ));
  };

  return (
    <Dropdown
      inputValue={inputValue}
      selectedItems={selectedItems}
      onSelect={items => setSelectedItems(items)}
      downshiftProps={{ defaultHighlightedIndex: 0 }}
      onStateChange={changes => {
        if (Object.prototype.hasOwnProperty.call(changes, 'inputValue')) {
          setInputValue(changes.inputValue);
        }
      }}
    >
      <Field>
        <Label>Select countries:</Label>
        <Hint>Add country you want to compare</Hint>
        <Multiselect
          isCompact
          renderItem={({ value, removeValue }) => (
            <Tag>
              <span>{value}</span>
              <Tag.Close onClick={() => removeValue()} />
            </Tag>
          )}
        />
      </Field>
      <Menu isCompact>{renderOptions()}</Menu>
    </Dropdown>
  );
}

export default CountriesDropdown;
